<template>
<div>
  <div v-if="!loggedIn">
    <b-alert v-model="showConfirmationEmailAlert" variant="success" dismissible>
      <strong>User successfully registered</strong>. An e-mail message containing a confirmation link has been sent to <strong>{{confirmationLinkEmail}}</strong>
    </b-alert>
    <b-alert v-model="showAlreadyRegisteredAlert" variant="danger" dismissible>
      <strong>ERROR:</strong> This email address is already registered
    </b-alert>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <router-link class="nav-link" :class="{ 'active' : path === '/register' }" to="/register">Register</router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" :class="{ 'active' : path === '/login' }" to="/login">Change Password</router-link>
      </li>
    </ul>
    <router-view></router-view>
  </div>
  <div v-if="loggedIn">
    <ChangePassword />
  </div>
</div>
</template>

<script>
import ChangePassword from './ChangePassword.vue';

export default {
  name: 'Main',
  components: {
    ChangePassword
  },
  computed: {
    loggedIn() { return this.$store.state.loggedIn },
    path() { return this.$route.path },
    confirmationLinkEmail() { return this.$store.state.confirmationLinkEmail },
    showConfirmationEmailAlert: {
      get() { return this.$store.state.confirmationLinkEmail !== null },
      set(value) {
        if (!value) {
          this.$store.commit('setConfirmationLinkEmail', null);
        }
        return value;
      }
    },
    showAlreadyRegisteredAlert: {
      get() { return this.$store.state.registrationResult === 'ALREADY_IN_LDAP' },
      set(value) {
        if (!value) {
          this.$store.commit('setRegistrationResult', null);
        }
        return value;
      }
    }
  }
}
</script>
